import React, { useEffect } from "react";
import diet from "../../assets/diet.png";
// import right from "../../assets/right.png";
// import left from "../../assets/left.png";
import dos from "../../assets/do.png";
import dont from "../../assets/dont.png";
import mom1 from "../../assets/1strimes.png";
import mom2 from "../../assets/2ndtrimes.png";
import mom3 from "../../assets/3rdtrimes.png";
import baby1 from "../../assets/deve.png";
import baby2 from "../../assets/baby2v.png";
import baby3 from "../../assets/baby3.png";
import utube from "../../assets/youtube.jpg";
import "./video.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Videos({ selectedTool, setSelectedTool }) {
  useEffect(() => {
    setSelectedTool("/videos");
  }, []);

  return (
    <div className="vidbase">
      <Helmet>
        <title>Helpful Pregnancy Videos: Optimise Your Parenting Journey</title>
        <meta
          name="description"
          content="Check out pregnancy-related videos filled with helpful tips and advice, offering the support and information you need for a healthy pregnancy journey."
        />
        <meta
          name="keywords"
          content="Pregnancy videos, pregnancy tips, pregnancy stages"
        />
      </Helmet>
      <div className="vidmain">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Videos</li>
            </ol>
          </nav>
        </div>
        <div className="vid-head">
          <h1 style={{ textTransform: "initial", textAlign: "center" }}>
            Videos
          </h1>
          <h4>For Mom-to-Be & Little One</h4>
          <img src={utube} alt="You_Logo" className="youtube-logo" />
        </div>

        <div className="video-row">
          <Link to="dietchart">
            {" "}
            <img src={diet} alt="Diet" className="babyonpalm fadeInUp" />
          </Link>
          <Link to="pregnancy-dos">
            <img src={dos} alt="Dos" className="babyonpalm fadeInUp" />
          </Link>

          <Link to="pregnancy-donts">
            <img src={dont} alt="Don'ts" className="babyonpalm fadeInUp" />
          </Link>
          <Link to="trimester-1-mom">
            <img
              src={mom1}
              alt="1st Trimester"
              className="babyonpalm fadeInUp"
            />
          </Link>
          <Link to="trimester-2-mom">
            <img
              src={mom2}
              alt="2nd Trimester"
              className="babyonpalm fadeInUp"
            />
          </Link>
          <Link to="trimester-3-mom">
            <img
              src={mom3}
              alt="3rd Trimester"
              className="babyonpalm fadeInUp"
            />
          </Link>
          <Link to="trimester-1-baby">
            <img
              src={baby1}
              alt="Baby Development 1"
              className="babyonpalm fadeInUp"
            />
          </Link>
          <Link to="trimester-2-baby">
            <img
              src={baby2}
              alt="Baby Development 2"
              className="babyonpalm fadeInUp"
            />
          </Link>

          <Link to="trimester-3-baby">
            <img
              src={baby3}
              alt="Baby Development 3"
              className="babyonpalm fadeInUp"
            />
          </Link>
        </div>

        <div className="video-row"></div>
      </div>
    </div>
  );
}

export default Videos;
